import { render } from "./ProjectManagerModule.vue?vue&type=template&id=720cc86a&ts=true&lang=true"
import script from "./ProjectManagerModule.vue?vue&type=script&lang=ts"
export * from "./ProjectManagerModule.vue?vue&type=script&lang=ts"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__